import * as React from "react";
import { Spinner, SpinnerColor, Text, TextVariant } from "../../ui";

/** A wait the technician can see is still moving: a spinner beside the message. */
export const LoadingMessage: React.FC<{
  variant?: TextVariant.BODY1 | TextVariant.BODY2;
  className?: string;
}> = ({ variant = TextVariant.BODY2, className, children }) => (
  <span role="status" className={`inline-flex items-center gap-2 text-gray-400 ${className ?? ""}`}>
    <Spinner size={variant === TextVariant.BODY1 ? 18 : 16} color={SpinnerColor.INHERIT} thickness={5} aria-hidden />
    <Text variant={variant} as="span">
      {children}
    </Text>
  </span>
);
